
import api from 'api';
import { processPromise, obj2Prams } from '@helpers/functions';

const usuario = {};

usuario.retrieve = (params = {}) => {
  const querystring = obj2Prams(params);

  return new Promise((resolve, reject) => {
    let endpoint = `/usuarios`;
    endpoint = querystring ? `${endpoint}?${querystring}` : endpoint;

    api.get(endpoint).then((result) => {
      const response = processPromise(true, result)
      resolve(response);
    }).catch((error) => {
      processPromise(false, error)
      reject(error);
    });
  });
}

usuario.show = (_id) => {
  return new Promise((resolve, reject) => {
    let endpoint = `/usuario/${_id}`;
    api.get(endpoint).then((result) => {
      const response = processPromise(true, result)
      resolve(response);
    }).catch((error) => {
      processPromise(false, error)
      reject(error);
    });
  });
}

usuario.save = (_id, data) => {
  return new Promise((resolve, reject) => {
    let endpoint = `/usuario`;
    endpoint = _id ? `${endpoint}/${_id}` : endpoint;
    api.post(endpoint, data).then((result) => {
      const response = processPromise(true, result)
      resolve(response);
    }).catch((error) => {
      processPromise(false, error)
      reject(error);
    });
  });
}

export default usuario
